import { $ } from '@situation/setdesign.util';

const scrollCalendarHeading = html` <p class="legend">
    <span class="icon text--primary">
        <svg><use xlink:href="#icon-star"></use></svg>
    </span>
    <span>= Selling Fast</span>
</p>`;
$(document).one('TicketCalendar.init', (e, TicketCalendar, $on) => {
    $on(TicketCalendar.FILTER_DEFAULTS, (defaults) => {
        defaults.update({
            // set to the $tc-theme-name sass variable
            theme: 'outsiders-theme',
            'disable-default-analytics': true,
            'accordion-month-header': { arrowSvgName: 'icon-arrow' },
            'calendar-week-header': { headerFormat: 'ddd, MMM D' },
            'calendar-list-item': { eventDateFormat: 'ddd, MMM D' },
            'scroll-calendar': { instructionText: scrollCalendarHeading },
            'selected-date-performances': { buttonClass: 'button' },
            fullcalendar: {
                prevIcon: '<span class="icon icon-use"><svg><use xlink:href="#icon-arrow"></use></svg></span>',
                nextIcon: '<span class="icon icon-use"><svg><use xlink:href="#icon-arrow"></use></svg></span>',
            },
        });
    });
    // TURNED OFF FOR NOW
    // $on('fc-view-render', (view, element) => {
    //     const $calendar = $(element);
    //     const $toolbar = $calendar.find('.fc-header-toolbar');
    //     if (!$toolbar.length || $calendar.find('.tc-calendar-instruction').length) {
    //         return;
    //     }
    //     $('<div class="tc-calendar-instruction"></div>').html(scrollCalendarHeading).insertAfter($toolbar);
    // });
});
